import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type CocktailIconProps = CreateIconComponentProps;
export const CocktailIcon: React.FC<CocktailIconProps> = ({
  title = 'Cocktail',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 22h4M11 17v5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7v5.833C16 15.343 13.762 17 11 17s-5-1.657-5-4.167V7h10Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 11c1.481-1.333 3.519-1.333 5 0 1.482 1.333 3.518 1.333 5 0"
    />
    <path stroke="currentColor" strokeWidth="2" d="M16 10.5A3.5 3.5 0 1 0 12.5 7" />
  </CreateIconComponent>
);
